import { apiClient } from './client'
import type {
  StartEmailValidationResponseDto,
  PollEmailValidationResponseDto,
  FullUserResponseDto,
} from '@/types/api'

/** Pick bearer token from login responses (API may use `accessToken` or `sessionToken`). */
export function pickAccessToken(data: {
  accessToken?: string
  sessionToken?: string
}): string | null {
  const t = data.accessToken ?? data.sessionToken
  return typeof t === 'string' && t.length > 0 ? t : null
}

export function validateEmailForLogin(email: string): Promise<StartEmailValidationResponseDto> {
  return apiClient
    .post<StartEmailValidationResponseDto>('/v1/auth/validate-email-for-login', { email,"source": "web" })
    .then((res) => res.data)
}

export function pollEmailValidation(confirmToken: string): Promise<PollEmailValidationResponseDto> {
  return apiClient
    .post<PollEmailValidationResponseDto>('/v1/auth/poll-email-validation', { confirmToken })
    .then((res) => res.data)
}

export function completeEmailValidation(
  emailToken: string
): Promise<PollEmailValidationResponseDto> {
  return apiClient
    .post<PollEmailValidationResponseDto>('/v1/auth/complete-email-validation', { emailToken })
    .then((res) => res.data)
}

export function getUserDetails(): Promise<FullUserResponseDto> {
  return apiClient.get<FullUserResponseDto>('/v1/user/details').then((res) => res.data)
}
